import {createStore} from 'vuex'

import LocalizationLanguage from "@/store/localization/language";
import LocalizationTax from "@/store/localization/tax";
import LocalizationCountry from "@/store/localization/country";
import LocalizationCountryState from "@/store/localization/country/state";
import LocalizationCountryCity from "@/store/localization/country/city";
import AuthModule from "@/store/module/AuthModule";
import BodyModule from "@/store/module/BodyModule";
import BreadcrumbsModule from "@/store/module/BreadcrumbsModule";
import ConfigModule from "@/store/module/ConfigModule";
import File from "@/store/file";
import EcommerceProduct from "@/store/ecommerce/product/";
import EcommerceProductBrand from "@/store/ecommerce/product/collation/brands/";
import EcommerceProductCategory from "@/store/ecommerce/product/collation/category/";
import EcommerceProductGroup from "@/store/ecommerce/product/collation/product-groups/";
import EcommerceProductSupplier from "@/store/ecommerce/product/collation/suppliers/";
import EcommerceProductUnit from "@/store/ecommerce/product/collation/product-units/";
import EcommerceProductVariantGroup from "@/store/ecommerce/product/collation/variant-types/group/";
import EcommerceProductVariantItem from "@/store/ecommerce/product/collation/variant-types/item/";
import EcommerceProductVariantCombination from "@/store/ecommerce/product/collation/variant-types/combination/";
import EcommerceProductAttributeSet from "@/store/ecommerce/product/attribute/set/";
import EcommerceProductAttributeField from "@/store/ecommerce/product/attribute/field/";
import EcommerceProductAttributeOption from "@/store/ecommerce/product/attribute/option/";
import EcommerceStockWarehouse from "@/store/ecommerce/stock/warehouse/";
import EcommerceStockStatus from "@/store/ecommerce/stock/status/";
import EcommerceStockMovement from "@/store/ecommerce/stock/movement/";
import EcommerceStockPurchase from "@/store/ecommerce/stock/purchase/";
import EcommerceStockTransfer from "@/store/ecommerce/stock/transfer/";
import EcommerceStockCount from "@/store/ecommerce/stock/count/";
import EcommerceOrder from "@/store/ecommerce/order/";
import EcommerceCartLink from "@/store/ecommerce/cart-link/";
import EcommerceGiftCard from "@/store/ecommerce/order/giftCard/";
import EcommerceAbandonedCart from "@/store/ecommerce/order/abandonedCart/";
import EcommerceAutomation from "@/store/ecommerce/automation/";
import EcommerceMarketingCampaign from "@/store/ecommerce/marketing/";
import EcommerceOrderDraft from "@/store/ecommerce/order/draft/";
import EcommerceSalesChannel from "@/store/ecommerce/sales-channel/";
import EcommerceCustomer from "@/store/ecommerce/customer/";
import EcommerceCustomerGroup from "@/store/ecommerce/customer/group/";
import EcommercePriceList from "@/store/ecommerce/product/priceList/";
import EcommerceApp from "@/store/ecommerce/app/";
import EcommerceTrendyol from "@/store/ecommerce/trendyol/";
import EcommerceShopier from "@/store/ecommerce/shopier/";
import EcommerceProductCatalog from "@/store/ecommerce/productCatalog/";
import EcommerceDiscountCoupon from "@/store/ecommerce/discount/coupon/";
import EcommerceDiscountCampaign from "@/store/ecommerce/discount/campaign/";
import EcommerceDiscountCampaignOffer from "@/store/ecommerce/discount/campaignOffer/";
import EcommerceTag from "@/store/ecommerce/tag/";
import SiteSliderGroup from "@/store/site/slider/group/";
import SiteSliderItem from "@/store/site/slider/item/";
import SiteSliderButton from "@/store/site/slider/button/";
import SiteBlogPost from "@/store/site/blog/post/";
import SiteBlogCategory from "@/store/site/blog/category/";
import SiteFeaturedProductGroup from "@/store/site/featured-product/group/";
import SiteFeaturedProductItem from "@/store/site/featured-product/item/";
import SitePopupItem from "@/store/site/popup/item/";
import SitePopupButton from "@/store/site/popup/button/";
import SitePageItem from "@/store/site/page/item/";
import SiteFormItem from "@/store/site/form/item/";
import SiteFormElement from "@/store/site/form/element/";
import SiteFormAnswer from "@/store/site/form/answer/";
import SiteLinkManager from "@/store/site/link/manager/";
import SiteMenuManager from "@/store/site/menu/manager/";
import SiteMenuItem from "@/store/site/menu/item/";
import SiteFaqGroup from "@/store/site/faq/group/";
import SiteFaqCategory from "@/store/site/faq/category/";
import SiteFaqItem from "@/store/site/faq/item/";
import SiteLocalizationLanguage from "@/store/site/localization/language";
import SiteLocalizationCurrency from "@/store/site/localization/currency";
import SiteLocalizationTax from "@/store/site/localization/tax";
import SiteLocalizationCountry from "@/store/site/localization/country";
import SiteLocalizationCountryState from "@/store/site/localization/country-state";
import SiteLocalizationCountryCity from "@/store/site/localization/country-city";
import SiteAdminUser from "@/store/site/admin/user/";
import SiteAdminGroup from "@/store/site/admin/group/";
import Permission from "@/store/permission/";
import SiteSettingsSystemVariable from "@/store/site/settings/system-variable";
import SiteSettingsRegisterElement from "@/store/site/settings/register-element";
import SiteSettingsTrackingCode from "@/store/site/settings/tracking-code";
import SiteSettingsStreamProvider from "@/store/site/settings/stream-provider";
import SiteSettingsStreamProviderAccount from "@/store/site/settings/stream-provider-account";

//Default
export const store = createStore({
        modules: {
            AuthModule,
            BodyModule,
            BreadcrumbsModule,
            ConfigModule,
            permission: Permission,
            localization: {
                namespaced: true,
                modules: {
                    language: LocalizationLanguage,
                    tax: LocalizationTax,
                    country: Object.assign(LocalizationCountry, {
                        modules: {
                            state: LocalizationCountryState,
                            city: LocalizationCountryCity,
                        }
                    })
                }
            },
            file: File,
            ecommerce: {
                namespaced: true,
                modules: {
                    product: Object.assign(EcommerceProduct, {
                        modules: {
                            collation: {
                                namespaced: true,
                                modules: {
                                    brand: EcommerceProductBrand,
                                    category: EcommerceProductCategory,
                                    productGroup: EcommerceProductGroup,
                                    supplier: EcommerceProductSupplier,
                                    unit: EcommerceProductUnit,
                                    variant: {
                                        namespaced: true,
                                        modules: {
                                            group: EcommerceProductVariantGroup,
                                            item: EcommerceProductVariantItem,
                                            combination: EcommerceProductVariantCombination,
                                        }
                                    },
                                }
                            },
                            attribute: {
                                namespaced: true,
                                modules: {
                                    set: EcommerceProductAttributeSet,
                                    field: EcommerceProductAttributeField,
                                    option: EcommerceProductAttributeOption,
                                }
                            }
                        }
                    }),
                    order: EcommerceOrder,
                    customer: EcommerceCustomer,
                    customerGroup: EcommerceCustomerGroup,
                    priceList: EcommercePriceList,
                    app: EcommerceApp,
                    trendyol: EcommerceTrendyol,
                    shopier: EcommerceShopier,
                    productCatalog: EcommerceProductCatalog,
                    tag: EcommerceTag,
                    cartLink: EcommerceCartLink,
                    giftCard: EcommerceGiftCard,
                    abandonedCart: EcommerceAbandonedCart,
                    automation: EcommerceAutomation,
                    marketingCampaign: EcommerceMarketingCampaign,
                    orderDraft: EcommerceOrderDraft,
                    salesChannel: EcommerceSalesChannel,
                    stock: {
                        namespaced: true,
                        modules: {
                            warehouse: EcommerceStockWarehouse,
                            status: EcommerceStockStatus,
                            movement: EcommerceStockMovement,
                            purchase: EcommerceStockPurchase,
                            transfer: EcommerceStockTransfer,
                            count: EcommerceStockCount,
                        }
                    },
                    discount: {
                        namespaced: true,
                        modules: {
                            coupon: EcommerceDiscountCoupon,
                            campaign: EcommerceDiscountCampaign,
                            campaignOffer: EcommerceDiscountCampaignOffer,
                        }
                    },
                }
            },
            site: {
                namespaced: true,
                modules: {
                    slider: {
                        namespaced: true,
                        modules: {
                            group: SiteSliderGroup,
                            item: SiteSliderItem,
                            button: SiteSliderButton,
                        }
                    },
                    blog: {
                        namespaced: true,
                        modules: {
                            post: SiteBlogPost,
                            category: SiteBlogCategory,
                        }
                    },
                    featuredProduct: {
                        namespaced: true,
                        modules: {
                            group: SiteFeaturedProductGroup,
                            item: SiteFeaturedProductItem,
                        }
                    },
                    popup: {
                        namespaced: true,
                        modules: {
                            item: SitePopupItem,
                            button: SitePopupButton,
                        }
                    },
                    page: {
                        namespaced: true,
                        modules: {
                            item: SitePageItem,
                        }
                    },
                    form: {
                        namespaced: true,
                        modules: {
                            item: SiteFormItem,
                            element: SiteFormElement,
                            answer: SiteFormAnswer,
                        }
                    },
                    link: {
                        namespaced: true,
                        modules: {
                            manager: SiteLinkManager,
                        }
                    },
                    menu: {
                        namespaced: true,
                        modules: {
                            manager: SiteMenuManager,
                            item: SiteMenuItem,
                        }
                    },
                    faq: {
                        namespaced: true,
                        modules: {
                            group: SiteFaqGroup,
                            category: SiteFaqCategory,
                            item: SiteFaqItem,
                        }
                    },
                    localization: {
                        namespaced: true,
                        modules: {
                            language: SiteLocalizationLanguage,
                            currency: SiteLocalizationCurrency,
                            tax: SiteLocalizationTax,
                            country: SiteLocalizationCountry,
                            countryState: SiteLocalizationCountryState,
                            countryCity: SiteLocalizationCountryCity,
                        }
                    },
                    admin: {
                        namespaced: true,
                        modules: {
                            user: SiteAdminUser,
                            group: SiteAdminGroup,
                        }
                    },
                    settings: {
                        namespaced: true,
                        modules: {
                            systemVariable: SiteSettingsSystemVariable,
                            registerElement: SiteSettingsRegisterElement,
                            trackingCode: SiteSettingsTrackingCode,
                            streamProvider: SiteSettingsStreamProvider,
                            streamProviderAccount: SiteSettingsStreamProviderAccount,
                        }
                    }
                }
            }
        }
    })
;


export default store;